import OrdersService from "../../../services/orders.service";
import axios from "axios";
import { API_URL } from "../../../services/constants";

export default {
  methods: {
    getBase(path) {
      let basePath = path.split("/");
      basePath.pop();
      return basePath.join("/") + "/";
    },
    async downloadFileFromServer(itemName, orderNo, fileUrl, printedText) {
      try {
        this.downloadInProgress = true;
        let data = {
          itemName,
          orderNo,
          fileUrl,
          printedText,
        };
        let fileResponse = await OrdersService.renameAndDownloadFile(data);

        axios({
          url: `${API_URL}orders/download-file`,
          method: "GET",
          responseType: "blob",
          params: {
            fileName: fileResponse.data.fileName,
          },
        }).then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");

          fileLink.href = fileURL;
          fileLink.setAttribute("download", fileResponse.data.fileName);
          document.body.appendChild(fileLink);

          fileLink.click();

          this.downloadInProgress = false;
        });
      } catch (errors) {
        console.log(errors);
        this.downloadInProgress = false;
      }
    },
  },
};
